/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable object-curly-newline */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as Joi from 'joi-browser';
import qs from 'qs';

import withStyles from '@material-ui/core/styles/withStyles';
import Button from '@material-ui/core/Button';

import Form from '../../common/Form';
import { form } from '../../style/form';
import EventDispatcher from '../../state/reducers/EventDispatcher';
import { uuidv4 } from '../../utils/uuid';
import { cipher } from '../../utils/crypto';
import { isEmpty } from '../../utils/object';
import Divider from '../../common/Divider';
import ErrorInline from '../../common/ErrorMessages/ErrorInline';
import configENV from '../../config';

const { AUTH_LOGIN_URL, PERSIST_KEY } = configENV;
const styles = ({ typography, palette }) => form(typography, palette);

class TrackOrderByZipCode extends Form {
    state = {
        data: {
            orderNumber: '',
            zipCode: '',
            // callBack: '',
            // uuid: '',
        },
        isSubmited: false,
        errors: {},
        replaceMask: {
            orderNumber: '*',
        },
        replaceMaskWith: {
            orderNumber: 'toUpperCase',
        },
    };

    schema = {
        orderNumber: Joi.string()
            .trim()
            .regex(/^W?\d{8,30}$/i, 'order number format') // this regex will recieve order number with W or without min length 8 max is 30
            .min(8)
            .max(30)
            .required()
            .label('Order Number'),
        zipCode: Joi.string()
            .trim()
            .min(5)
            .max(10)
            .required()
            .label('Recipient Zip Code'),
        // uuid: Joi.any().optional(),
        // callBack: Joi.any().optional(),
    };

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillMount = () => {
        const { data } = this.state;
        const { location } = this.props;
        if (location && location.search) {
            const params = qs.parse(location.search);
            if (params.orderStatusId && params.orderStatusId.match(/^[W]?\d+$/) && params.zipCode) {
                data.orderNumber = params.orderStatusId;
                data.zipCode = params.zipCode;
                this.setState({ data });
            }
        }
    };

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillReceiveProps = (props) => {
        const { isSubmited } = this.state;
        const { isReadyState, callBack, history, orderDetails, uuid } = props;
        if (
            isSubmited
            && isReadyState
            && callBack
            && callBack.url
            && orderDetails
            && !isEmpty(orderDetails[uuid])
            && callBack.url !== props.location.pathname
        ) {
            history.push(callBack.url);
        }
    };

    handleSignInClicked = () => {
        this.props.history.push(AUTH_LOGIN_URL);
    };

    doSubmit = (submitData) => {
        const data = { ...this.state.data };
        const uuid = uuidv4();
        const cipherKey = uuid.slice(0, 8);
        data.uuid = uuid;
        data.cryptedOrderNumber = cipher(cipherKey)(data.orderNumber).replace(
            /^(.{8})(.{4})(.{4})(.{4})(.+)$/,
            '$1-$2-$3-$4-$5',
        );
        data.cryptedZipCode = cipher(cipherKey)(data.zipCode);
        const url = [
            '/account/orders/',
            data.uuid,
            '/',
            data.cryptedOrderNumber,
            '/',
            data.cryptedZipCode,
        ].join('');
        data.callBack = { url };
        this.setState({ isSubmited: true }, () => {
            submitData.handleSubmitOrderByZipCode(data);
        });
    };

    render() {
        /* eslint-disable max-len */
        const { isReadyState, classes, handleSubmitOrderByZipCode } = this.props;
        // const { data } = this.state;
        const submitData = { handleSubmitOrderByZipCode };

        // console.log(this.props);

        return (
            <>
                <h2 className="padding-top no-margin-bottom">
                    Sign in to get order detail(s)
                </h2>
                <div className="row">
                    <Button
                        onClick={() => this.handleSignInClicked()}
                        variant="contained"
                        color="primary"
                        className="remove-recipient-btn buttonHD margin-top-2x"
                        type="button"
                    >
                        Sign In
                    </Button>
                </div>
                <Divider text="or" />
                <h2>Track by order # without signing in</h2>
                <form
                    onSubmit={(event) => this.handleSubmit(event, submitData)}
                    className={`${classes.form} row padding-bottom-2x`}
                    disabled={!isReadyState}
                >
                    {/* eslint-disable-next-line react/jsx-props-no-spreading */}
                    <ErrorInline {...this.props} />
                    {this.renderInput({
                        name: 'orderNumber',
                        label: 'Order Number',
                        type: 'text',
                        pattern: '^[wW0-9]*$',
                        length: 30,
                    })}
                    {this.renderInput({
                        name: 'zipCode',
                        label: 'Recipient Zip Code',
                        type: 'text',
                        pattern: '^[a-zA-Z\\s\\-0-9]*$',
                        length: 10,
                    })}

                    <div className="margin-top-2x opacity1">
                        {this.renderButton({
                            label: isReadyState ? 'Submit' : 'Submitting...',
                            className: isReadyState
                                ? 'buttonHD submit-btn'
                                : 'buttonHD buttonDisabled',
                            onClick: null,
                            type: 'submit',
                        })}
                    </div>
                </form>
            </>
        );
    }
}

TrackOrderByZipCode.defaultProps = {
    handleSubmitOrderByZipCode: () => { },
    router: {},
};

TrackOrderByZipCode.propTypes = {
    isReadyState: PropTypes.bool.isRequired,
    classes: PropTypes.object.isRequired,
    router: PropTypes.object,
    handleSubmitOrderByZipCode: PropTypes.func,
};

const mapStateToProps = (state) => {
    /* istanbul ignore next */
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    return {
        isReadyState: newState.isReadyState,
        toggleState: newState.toggleState,
        callBack: newState.callBack,
        orderDetails: newState.orderDetails,
        uuid: newState.uuid,
        error: newState.error,
    };
};

const mapDispatchToProps = (dispatch) => ({
    handleSubmitOrderByZipCode: (data) => dispatch(EventDispatcher.handleSubmitOrderByZipCode(data)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(withStyles(styles)(TrackOrderByZipCode)));
